import { FC, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { FarmContext } from "../../AppContent";
import { FarmConsentInfoBox } from "../../Components/Consent/FarmConsentInfoBox";
import { giveFarmConsent, withdrawFarmConsent } from "../../repos/FarmRepo";

export const FarmConsentPage: FC = () => {
  const { t } = useTranslation();
  const { farm, reloadFarm } = useContext(FarmContext);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConsentToggle = () => {
    if (!farm?.uuid || isSubmitting) return;

    setIsSubmitting(true);
    const submitRequest = !!farm?.consent
      ? withdrawFarmConsent(farm.uuid)
      : giveFarmConsent(farm.uuid);

    submitRequest
      .then(() => reloadFarm())
      .catch(() => {})
      .finally(() => setIsSubmitting(false));
  };

  return (
    <div className="page-content">
      <FarmConsentInfoBox
        title={t("DashboardConsentTitle")}
        buttonLabel={t(
          !!farm?.consent
            ? "FarmConsentWithdrawButton"
            : "DashboardConsentButton"
        )}
        onButtonClick={handleConsentToggle}
        buttonDisabled={!farm?.uuid || isSubmitting}
      />
    </div>
  );
};
